/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSignatureRequestDto
 */
export interface UpdateSignatureRequestDto {
    /**
     * Digital signature image URL
     * @type {string}
     * @memberof UpdateSignatureRequestDto
     */
    signatureUrl: string;
}

/**
 * Check if a given object implements the UpdateSignatureRequestDto interface.
 */
export function instanceOfUpdateSignatureRequestDto(value: object): value is UpdateSignatureRequestDto {
    if (!('signatureUrl' in value) || value['signatureUrl'] === undefined) return false;
    return true;
}

export function UpdateSignatureRequestDtoFromJSON(json: any): UpdateSignatureRequestDto {
    return UpdateSignatureRequestDtoFromJSONTyped(json, false);
}

export function UpdateSignatureRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSignatureRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'signatureUrl': json['signatureUrl'],
    };
}

export function UpdateSignatureRequestDtoToJSON(json: any): UpdateSignatureRequestDto {
    return UpdateSignatureRequestDtoToJSONTyped(json, false);
}

export function UpdateSignatureRequestDtoToJSONTyped(value?: UpdateSignatureRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signatureUrl': value['signatureUrl'],
    };
}

